/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./DonationInfoEdit.css";
import { simpleFetch } from "../../restWrapper";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PropTypes from "prop-types";
import { validPaymentInfo } from "../../assets/validators/payment.js";
import { NumericFormat } from "react-number-format";
import { renderErrorMsg } from "../../assets/component/renderErrorMsg.js";
import { Helmet } from "react-helmet";
import { resolveThemeColors } from "../../assets/helper";

import { donationOf } from "../DonationInfoRecurring/donationOf";

class CustomCalendarInput extends Component {
  render() {
    return (
      <input
        onClick={this.props.onClick}
        onChange={this.props.onChange}
        value={this.props.value}
        className="DonationInfoEdit-dateField"
        type="text"
      />
    );
  }
}

CustomCalendarInput.propTypes = {
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

class DonationInfoEdit extends Component {
  constructor(props) {
    super(props);
    if (!this.props.location.state.paymentId) {
      this.props.history.push("/donationRecordRecurring");
    }

    this.onClickOkBtn = this.onClickOkBtn.bind(this);
    this.onClickDeleteBtn = this.onClickDeleteBtn.bind(this);

    this.state = {
      ...{
        minDate: new Date(),
        startDate: new Date(),
        loading: true,
        errMsgs: [],
        isInfiniteRecurring: false, // Track if donation is infinite recurring
      },
      ...this.props.location.state,
    };

    this.handleInfiniteRecurringToggle = this.handleInfiniteRecurringToggle.bind(this);

    this.handleDateChange = (date) => {
      let data = this.state.data;
      data.scheduledDate = moment(date).toISOString(false);
      this.setState({
        ...this.state,
        ...{
          data: data,
          startDate: date,
        },
      });
    };

    this.handleAmountChange = (e) => {
      let amount = e.target.value;

      let amountSplit = amount.split("$");
      if (!amountSplit[1]) return false;
      amountSplit = amountSplit[1].split(",");

      let a = "";
      for (var i = 0; i < amountSplit.length; i++) {
        a += amountSplit[i];
      }

      const isAmount = validPaymentInfo.validAmount(
        a,
        this.state.minimumPaymentAmount,
      );
      const numberAmount = Number(a);
      let data = this.state.data;
      data.amount = numberAmount;
      this.setState({
        data: data,
        validData: isAmount,
      });
    };
  }

  componentDidMount() {
    simpleFetch(
      "/donors/payments/" + this.props.location.state.paymentId,
      "GET",
      {},
    ).then((res) => {
      this.setState({
        loading: false,
      });
      if (res.status !== 200)
        this.props.history.push("/Transactions/scheduled");
      let data = res.body;
      // Edit the donation, not the total with fees (CP-386)
      data.amount = donationOf(data);
      this.originalDonation = data.amount;
      let minimumPaymentAmount = 0;
      try {
        minimumPaymentAmount =
          this.props.location.state.organization.minimumPaymentAmount;
      } catch (e) {
        minimumPaymentAmount = null;
      }
      if (minimumPaymentAmount) {
        this.setState({
          minimumPaymentAmount: minimumPaymentAmount,
        });
        const amount = data.amount;
        data.validData = validPaymentInfo.validAmount(
          !amount ? 0 : amount,
          minimumPaymentAmount,
        );
      } else {
        data.validData = 0;
      }
      let originalDate = new Date();
      originalDate.setDate(originalDate.getDate() + 1);
      try {
        if (data.scheduledDate)
          this.setState({
            startDate: new Date(data.scheduledDate),
          });
      } catch (e) {
        this.setState({
          startDate: originalDate,
        });
      }

      // Check if this is an infinite recurring donation
      const isInfiniteRecurring = data.isRecurring && !data.recurringEndDate;

      // console.log("DonationInfoEdit - Payment data:", data);
      // console.log("DonationInfoEdit - isRecurring:", data.isRecurring);
      // console.log("DonationInfoEdit - recurringInterval:", data.recurringInterval);
      // console.log("DonationInfoEdit - recurringEndDate:", data.recurringEndDate);
      // console.log("DonationInfoEdit - isInfiniteRecurring:", isInfiniteRecurring);

      this.setState({
        data: data,
        minDate: originalDate,
        isInfiniteRecurring: isInfiniteRecurring,
      });
    });
  }

  handleInfiniteRecurringToggle() {
    const newValue = !this.state.isInfiniteRecurring;
    this.setState({
      isInfiniteRecurring: newValue,
    });
  }

  onClickOkBtn() {
    /*
    'cardId',
    'scheduledDate',
    'amount',
    'currency',
    'memo',
    'recurringEndDate'
    */
    const paymentId = this.props.location.state.paymentId;

    let obj = {
      paymentId: paymentId,
    };

    const data = this.state.data;
    // The donation before fees, only when the donor changed it (CP-386)
    if (data.amount && Number(data.amount) !== Number(this.originalDonation)) {
      obj.donationAmount = data.amount;
    }

    if (data.memo) {
      obj.memo = data.memo;
    }

    if (data.scheduledDate) {
      obj.scheduledDate = data.scheduledDate;
    }

    // Handle recurring end date modification for recurring donations
    if (data.isRecurring) {
      if (this.state.isInfiniteRecurring) {
        obj.recurringEndDate = null; // Infinite recurring
      } else {
        // For finite recurring, keep existing end date or calculate new one
        // Note: Frontend should calculate end date based on occurrence count if needed
        obj.recurringEndDate = data.recurringEndDate;
      }
    }

    simpleFetch("/donors/payments/" + paymentId, "PUT", obj).then((res) => {
      if (res.status === 200) {
        this.props.history.push({
          pathname: "/donationInfoRecurring",
          state: this.props.location.state,
        });
      } else {
        if (res.body.message)
          this.setState({
            errMsgs: [res.body.message],
          });
      }
    });
  }

  onClickDeleteBtn() {
    var r = window.confirm("Delete this Payment?");
    if (r === true) {
      this.setState({
        loading: true,
      });
      simpleFetch(
        "/donors/payments/" + this.props.location.state.paymentId,
        "DELETE",
        {},
      ).then((res) => {
        if (res.status !== 200) {
          //    console.log("fail");
          this.setState({
            loading: false,
          });
        }
        this.setState({
          deleted: true,
        });
        setTimeout(
          function () {
            this.props.history.push("/donationRecordRecurring");
          }.bind(this),
          1000,
        );
        //    console.log('Deleted payment : '+this.props.location.state.paymentId);
      });
    }
  }

  renderRecord(data) {
    const headerStyle = {
      background: "#" + this.state.headerColor,
    };
    /*    const btnBgStyle = {
      background: '#' + this.state.buttonColor
    };
*/

    const languageObj = this.props.languageObj;

    return (
      <div className="DonationInfoEdit-view">
        <Helmet>
          <title>{this.state.orgName}</title>
        </Helmet>
        <div className="DonationInfoEdit-bg" style={headerStyle} />
        <div className="DonationInfoEdit-container">
          <div className="DonationInfoEdit-header">
            <div
              className="DonationInfoEdit-receiptContainer"
              onClick={this.onClickDeleteBtn}
            >
              <div className="DonationInfoEdit-receiptTxt">
                {languageObj.cancelBtn}
              </div>
            </div>
            <div
              className="DonationInfoEdit-finishContainer"
              onClick={this.onClickOkBtn}
            >
              <div className="DonationInfoEdit-finish">
                {languageObj.doneBtn}
              </div>
            </div>
          </div>

          <div className="DonationInfoEdit-main">
            <div className="DonationInfoEdit-inputContainer">
              <div>{this.state.errMsgs.map((err) => renderErrorMsg(err))}</div>
              <div className="DonationInfoEdit-heading">
                {this.state.orgName}
              </div>

              <div className="DonationInfoEdit-item">
                {languageObj.item}
                <div className="DonationInfoEdit-answer">
                  {data.projectName}
                </div>
              </div>
              <div className="DonationInfoEdit-item">
                {languageObj.processingDate}
                <div className="DonationInfoEdit-inputFieldContainer">
                  <DatePicker
                    selected={this.state.startDate}
                    minDate={this.state.minDate}
                    onChange={this.handleDateChange}
                    customInput={<CustomCalendarInput />}
                    dateFormat="yyyy/MM/dd"
                  />
                </div>
              </div>
              <div className="DonationInfoEdit-item">
                {languageObj.amount}
                <div className="DonationInfoEdit-inputFieldContainer">
                  <NumericFormat
                    pattern="[0-9]*"
                    inputMode="decimal"
                    decimalSeparator="."
                    className="DonationInfoEdit-inputField"
                    valueIsNumericString={true}
                    value={this.state.data.amount}
                    onChange={this.handleAmountChange}
                    allowNegative={false}
                    thousandSeparator={true}
                    prefix={"HK$"}
                    fixedDecimalScale={true}
                    decimalScale={2}
                  />
                </div>
              </div>

              <div className="DonationInfoEdit-item">
                {languageObj.paymentMethod}
                <div className="DonationInfoEdit-answer">
                  {data.cardBrand} - {data.cardLast4}
                </div>
              </div>

              {/* Recurring donation information */}
              {data.isRecurring && (
                <div className="DonationInfoEdit-item">
                  {languageObj.recurringType || "Recurring Type"}
                  <div className="DonationInfoEdit-answer">
                    {data.recurringInterval === 'weekly' && 'Weekly'}
                    {data.recurringInterval === 'biweekly' && 'Bi-weekly'}
                    {data.recurringInterval === 'monthly' && 'Monthly'}
                    {data.recurringInterval === 'yearly' && 'Yearly'}
                    {data.recurringInterval === 'daily' && 'Daily'}
                  </div>
                </div>
              )}

              {/* Infinite recurring toggle */}
              {data.isRecurring && (
                <div className="DonationInfoEdit-item">
                  {languageObj.continueUntilCancel || "Continue until I cancel"}
                  <div className="DonationInfoEdit-inputFieldContainer">
                    <input
                      type="checkbox"
                      checked={this.state.isInfiniteRecurring}
                      onChange={this.handleInfiniteRecurringToggle}
                      style={{ width: "20px", height: "20px", cursor: "pointer" }}
                    />
                  </div>
                </div>
              )}

              <div className="DonationInfoEdit-item">
                {languageObj.memo}
                <div className="DonationInfoEdit-answer">
                  {!this.state.data.memo ? "..." : this.state.data.memo}
                </div>
              </div>
            </div>

            <div className="DonationInfoEdit-chin" />
          </div>
        </div>
      </div>
    );
  }
  render() {
    if (this.state.loading) {
      return <this.props.RenderFullPageLoading />;
    }
    const data = this.state.data;
    if (this.state.deleted) return <div>deleted</div>;
    else if (!data)
      return (
        <div className="DonationInfoEdit-emptyPage">
          <div className="DonationInfoEdit-center">
            <div className="DonationInfoEdit-btm-load" />
          </div>
        </div>
      );
    else return this.renderRecord(data);
  }
}
DonationInfoEdit.propTypes = {
  languageObj: PropTypes.object,
};

export default DonationInfoEdit;
